(function () {
  'use strict';

  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function normalizeText(el) {
    return (el && el.textContent ? el.textContent : '').trim().toLowerCase();
  }

  function extractFirstNumber(text) {
    if (!text) return null;
    var m = String(text).match(/(\d+(?:\.\d+)?)/);
    if (!m) return null;
    var n = Number(m[1]);
    return Number.isFinite(n) ? n : null;
  }

  function extractReviewCount(widget) {
    if (!widget) return null;

    // Try data attributes first.
    var candidates = widget.querySelectorAll('[data-review-count],[data-yotpo-review-count],[data-reviews-count],[data-total-reviews]');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var v = el.getAttribute('data-review-count') || el.getAttribute('data-yotpo-review-count') || el.getAttribute('data-reviews-count') || el.getAttribute('data-total-reviews');
      var n = extractFirstNumber(v);
      if (n !== null) return Math.round(n);
    }

    // Fall back to text patterns.
    var text = normalizeText(widget);
    var m = text.match(/(\d+)\s+reviews?/i);
    if (m) return parseInt(m[1], 10);

    m = text.match(/based\s+on\s+(\d+)/i);
    if (m) return parseInt(m[1], 10);

    // Accessible labels sometimes include count.
    var ariaNodes = widget.querySelectorAll('[aria-label]');
    for (var j = 0; j < ariaNodes.length; j++) {
      var aria = ariaNodes[j].getAttribute('aria-label') || '';
      var m2 = aria.match(/(\d+)\s+reviews?/i);
      if (m2) return parseInt(m2[1], 10);
    }

    return null;
  }

  function extractAverageRating(widget) {
    if (!widget) return null;

    // Try common attributes.
    var rated = widget.querySelector('[data-rating],[data-score],[data-average-rating],[data-avg-rating]');
    if (rated) {
      var v = rated.getAttribute('data-rating') || rated.getAttribute('data-score') || rated.getAttribute('data-average-rating') || rated.getAttribute('data-avg-rating');
      var n = extractFirstNumber(v);
      if (n !== null) return n;
    }

    // Try accessible labels like "Rated 4.8 out of 5".
    var aria = widget.querySelector('[aria-label*="out of" i]');
    if (aria) {
      var label = aria.getAttribute('aria-label') || '';
      var m = label.match(/(\d+(?:\.\d+)?)\s*(?:out\s+of\s+5|\/\s*5)/i);
      if (m) return Number(m[1]);
    }

    // Last resort: parse text.
    var text = normalizeText(widget);
    var m2 = text.match(/(\d+(?:\.\d+)?)\s*(?:out\s+of\s+5|\/\s*5)/i);
    if (m2) return Number(m2[1]);

    return null;
  }

  function looksLikeHasStars(widget) {
    if (!widget) return false;

    // Yotpo tends to render star icons with various classnames.
    if (
      widget.querySelector(
        '.yotpo-stars, .yotpo-star-rating, .yotpo-review-stars, .yotpo-bottomline, [class*="yotpo-star"], [class*="star"]'
      )
    ) {
      return true;
    }

    // Some implementations use aria-labels for stars.
    var ariaStar = widget.querySelector('[aria-label*="star" i]');
    if (ariaStar) return true;

    return false;
  }

  function looksLikeNoReviews(widget) {
    var text = normalizeText(widget);
    if (!text) return true;

    // Common no-review strings (varies by widget config).
    if (
      text.includes('be the first') ||
      text.includes('no reviews') ||
      text.includes('0 reviews') ||
      text.includes('write a review') ||
      text.includes('write the first')
    ) {
      return true;
    }

    return false;
  }

  function applyState(container, state) {
    if (!container) return;
    container.classList.toggle('is-no-rating', state === 'none');
    container.setAttribute('data-rating-state', state);
  }

  function evaluate(container) {
    if (!container) return;

    var widget = container.querySelector('[data-grid-product-rating-widget]');
    if (!widget) return;

    // Explicit "no reviews" signal => show fallback.
    if (looksLikeNoReviews(widget)) {
      applyState(container, 'none');
      return;
    }

    // Prefer explicit signals of review count / rating value.
    var reviewCount = extractReviewCount(widget);
    if (reviewCount === 0) {
      applyState(container, 'none');
      return;
    }
    if (reviewCount && reviewCount > 0) {
      applyState(container, 'has');
      return;
    }

    var avg = extractAverageRating(widget);
    if (avg && avg > 0) {
      applyState(container, 'has');
      return;
    }

    // Stars are a good positive signal. If we did not detect explicit no-review, treat stars as "has".
    if (looksLikeHasStars(widget)) {
      applyState(container, 'has');
      return;
    }

    // Ambiguous/loading case: don't force a fallback.
    // This avoids showing "New Product" on everything when the widget hasn't rendered yet.
    applyState(container, 'unknown');
  }

  function initOne(container) {
    if (!container || container.hasAttribute('data-rating-fallback-initialized')) return;

    container.setAttribute('data-rating-fallback-initialized', 'true');
    applyState(container, 'unknown');

    var widget = container.querySelector('[data-grid-product-rating-widget]');
    if (!widget) return;

    // Re-evaluate a few times since widgets load async.
    window.setTimeout(function () { evaluate(container); }, 500);
    window.setTimeout(function () { evaluate(container); }, 2000);
    window.setTimeout(function () { evaluate(container); }, 5000);

    // Watch for the widget to render/replace markup.
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        evaluate(container);
      });

      mo.observe(widget, { childList: true, subtree: true, characterData: true });
      container._ratingFallbackObserver = mo;
    }
  }

  function initAll(scope) {
    qsa(scope, '[data-grid-product-rating]').forEach(initOne);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (evt) {
    if (!evt || !evt.target) return;
    initAll(evt.target);
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    if (!evt || !evt.target) return;
    qsa(evt.target, '[data-grid-product-rating]').forEach(function (container) {
      var mo = container._ratingFallbackObserver;
      if (mo && mo.disconnect) mo.disconnect();
    });
  });
})();
